import React from "react";
import PageTitleBanner from "../../../components/common/PageTitleBanner";

function AuctionBanner() {
  return <PageTitleBanner title="Auctions" />;
}

export default AuctionBanner;
